import {
    DEFAULT_PROJECT,
    ProjectsRepository as BaseProjectsRepository,
} from 'shared/projects/ProjectsRepository';
import { Selection } from 'src/projects/types/Selection';
import { RegionsEnum } from 'src/generated/operations.ts';

export { DEFAULT_PROJECT };

/**
 * SAS binding of the shared projects logic: fixes the selection type and accepts a localForage
 * store (which structurally satisfies the shared KeyValueStore) plus the region.
 */
export class ProjectsRepository extends BaseProjectsRepository<Selection> {
    public constructor(store: LocalForage, region: RegionsEnum, defaultProjectPrefix: string = DEFAULT_PROJECT) {
        super(store, region, defaultProjectPrefix);
    }
}
